import { SelectQuery } from '../inputs/selectQuery';
import { Switch } from '../inputs/switch';

import styles from './filter.module.css';

export const SearchFilter = ({
    filter,
    searchFilters,
    setSearchFilters,
    loading,
}) => {
    return (
        <label className={styles.Filter}>
            {filter.label}
            {filter.type === 'switch' ? (
                <Switch
                    className='thin'
                    initialValue={
                        searchFilters[filter.key] ?? filter.options[0].value
                    }
                    onChange={(e) => {
                        setSearchFilters((v) => {
                            const n = { ...v };
                            n[filter.key] = e;
                            return n;
                        });
                    }}
                    data={filter.options}
                />
            ) : filter.type === 'select' ? (
                <SelectQuery
                    value={searchFilters[filter.key]}
                    onChange={(e) => {
                        setSearchFilters((v) => {
                            const n = { ...v };
                            n[filter.key] = e === 'All' ? null : e;
                            return n;
                        });
                    }}
                    constantOptions={filter.allOption ? ['All'] : []}
                    placeholder={filter.label}
                    pluralResourceName={filter.label}
                    restEndpoint={filter.restEndpoint}
                    disabled={loading}
                    nameFunction={filter.nameFunction}
                    valueFunction={filter.valueFunction}
                    justName={true}
                    allowEmpty={true}
                />
            ) : filter.type === 'date' ? (
                <input
                    key={filter.key}
                    type='date'
                    placeholder={filter.label}
                    value={searchFilters[filter.key]}
                    disabled={loading}
                    onChange={(e) => {
                        setSearchFilters((v) => {
                            const n = { ...v };
                            n[filter.key] = e.target.value;
                            return n;
                        });
                    }}
                />
            ) : (
                <input
                    key={filter.key}
                    type='text'
                    placeholder={filter.label}
                    value={searchFilters[filter.key]}
                    disabled={loading}
                    onChange={(e) => {
                        setSearchFilters((v) => {
                            const n = { ...v };
                            n[filter.key] = e.target.value;
                            return n;
                        });
                    }}
                />
            )}
        </label>
    );
};
